<template>    
  <el-dialog 
    width="450px"
    title="修改密码" 
    :visible.sync="dialogEditPwd.isShow"
    :append-to-body="true"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="原密码">        
        <el-col :span="20">
          <el-input v-model="form.oldPwd" show-password></el-input>  
        </el-col>          
      </el-form-item>
      <el-form-item label="新密码">
        <el-col :span="20">
          <el-input v-model="form.newPwd" show-password></el-input>       
        </el-col>                 
      </el-form-item>
      <el-form-item label="确认密码">
        <el-col :span="20">
          <el-input v-model="form.comPwd" show-password></el-input>       
        </el-col>                 
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogEditPwd.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script  type='text/ecmascript-6'>
export default {
  props:{
    dialogEditPwd:{}
  },
  data (){
    return {
      form : {
        oldPwd:'',
        newPwd:'',
        comPwd:''
      },     
    }
  },  
  components:{
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
      this.form.oldPwd = ''
      this.form.newPwd = ''
      this.form.comPwd = ''
    },
    Save(){
      if(this.form.newPwd != this.form.comPwd ){
        this.$message.warning('确认密码必须和新密码一致!')
        return 
      }
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/User/EditPwd',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialogEditPwd.isShow = false
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },   
    handleIconSuccess(res, file){
      this.form.Icon= res.fullUrl
    },
  },
  created(){
  
  },
}
</script>